module.exports = __webpack_public_path__ + "static/gotland-images-2-d84670b25a650ba0dd53c63e936cea5e.jpg";